import { useMemo } from 'react';

import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getDashboardData } from 'src/apps/dashboard/services/dashboard/DashboardService';
import { DashboardDataResult } from 'src/apps/dashboard/services/queries/dashboard/helpers/transformResults';
import { REFETCH_INTERVAL } from 'src/common/consts/QueryConfigs';
import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import { DASHBOARD_DATA } from 'src/common/providers/reactQueryProvider/QueryKeys';
import { LabelsExcludedFromDashboard } from 'src/common/types/ConfigurationTypes';

export const useDashboardDataQuery = (
	filters?: IFilterOptions,
	labelsExcludedFromDashboard?: LabelsExcludedFromDashboard
): UseQueryResult<DashboardDataResult> => {
	const days = useMemo(() => {
		const dateRangeValue = filters?.dateRange?.[0]?.value;

		return dateRangeValue ? Number(dateRangeValue) : 30;
	}, [filters]);

	return useQuery({
		queryKey: [DASHBOARD_DATA, days, filters, labelsExcludedFromDashboard],
		queryFn: () => getDashboardData(days, filters, labelsExcludedFromDashboard),
		refetchInterval: REFETCH_INTERVAL
	});
};
